export default __webpack_public_path__ + "static/media/03.65b03725.jpg";